"use client";
import useTranslate from "@app/_hooks/useTranslate";

import { Tab } from "@headlessui/react";

import CompanyRegistrationForm from "./companyRegistrationForm";
import UserRegistrationForm from "./userRegistrationForm";

export default function RegistrationForms() {
  const t = useTranslate();
  return (
    <Tab.Group as="div" className="mt-6 md:mt-10">
      <Tab.List className="grid grid-cols-2 text-base text-gray-300">
        <Tab className="ui-selected:border-current ui-selected:text-black border-gray-150 border-b p-2">
          {t("individual")}
        </Tab>
        <Tab className="ui-selected:border-current ui-selected:text-black border-gray-150 border-b p-2">
          {t("company")}
        </Tab>
      </Tab.List>
      <Tab.Panels className="mt-6">
        <Tab.Panel tabIndex={-1}>
          <UserRegistrationForm />
        </Tab.Panel>
        <Tab.Panel tabIndex={-1}>
          <CompanyRegistrationForm />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
}
